window.SLIDECART_LOADED = function(cart) {
  // Fires once the cart has loaded
  $('#slidecarthq header h2').prepend("Shopping ");
  $('#slidecarthq footer button[name="checkout"]').text("Secure Checkout");
  $('<span class="cart-count first-bracket">(</span>').insertBefore('#slidecarthq header h2 .cart-count');
  $('<span class="cart-count">)</span>').insertAfter('#slidecarthq header h2 .cart-count:last-child');
  
  //$('.note-trigger').text('Add an optional note to packing slip');
  
  // Style any motivator items
  window.FOF.styleMotivatorItems(cart);
}

window.SLIDECART_UPDATED = function(cart) {
  // Fires whenevr slide cart has updated
  if ($('#slideCartSubtotalDisclaimer').length == 0) {
    $('<div id="slideCartSubtotalDisclaimer" class="subtotal-disclaimer"><span>Discounts, shipping, and taxes calculated at checkout.</span></div>').insertAfter('#slidecarthq footer div.footer-row');
  }  
  
  $('#slidecarthq footer button[name="checkout"]').text("Secure Checkout");

  if (typeof trigger_messages === "function") {
    if (BOLD.common.themeCartCallback == null) {
      BOLD.common.themeCartCallback = window.FOF.boldThemeCartCallback;
    }

    if (window.FOF.getIsDisplayed() == false) {
      window.FOF.setIsDisplayed(true);
      trigger_messages();
    } else {
      window.FOF.setIsDisplayed(false);
    }
  }
  
  var cart = window.SLIDECART_STATE().cart;
  
  window.FOF.styleMotivatorItems(cart);
  
  if (cart && cart.items && cart.items.length > 0) {
    $(cart.items).each(function(cartIndex, cartItem) {
      
      // Format products with options
      if (cartItem == null || cartItem.properties == null) {
        return;
      }
      
      // Get it's associated element
      //var $elem = $("[data-line-item-id=" + cartItem.id + "] .variants-p");
      var $elem = $("[data-line-item-key='" + cartItem.key + "'] .variants-p");
      var options = Object.getOwnPropertyNames(cartItem.properties);
      
      if (options && options.length > 0) {
        var props = [];
        
        $(options).each(function(optionIndex, optionText) {
          props.push(optionText + ": " + cartItem.properties[optionText]);
        });
        
        var str = props.join('<br/>');
        
        $elem.html(str);
      }
    });
  }

  // KLAVIYO //
  if (window.SLIDECART_ADDING_TO_CART == true) {
    window.SLIDECART_ADDING_TO_CART = false; // reset the flag
    var _learnq = window._learnq || [];
    _learnq.push(['track', 'Added to Cart', cart])
  }
}

window.SLIDECART_CLOSED = function() {
  // Fires whenever Slide Cart has been closed
  var itemCount = window.SLIDECART_STATE().cart.item_count;
  window.FOF.updateCartQuantityBadge(itemCount);
}

window.SLIDECART_OPENED = function() {
  // Fires whenever Slide Cart has been opened
}

window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
  // Fires whenever an item has been added to cart
  window.SLIDECART_ADDING_TO_CART = true; // set flag to check in the UPDATED event handler
}

function slideCartAddElems() {
  try {
    $('#slidecarthq header h2').prepend("Shopping ");
    // Customers Also Purchased
    // Customers Also Bought
    // You Might Also Enjoy
    // Frequently Bought Together
    $('#slidecarthq .upsells').prepend('<h2 id="fb">Frequently Bought Together</h2>');
    $('#slidecarthq footer button[name="checkout"]').text("Secure Checkout");
    $('<span class="cart-count first-bracket">(</span>').insertBefore('#slidecarthq header h2 .cart-count');
    $('<span class="cart-count">)</span>').insertAfter('#slidecarthq header h2 .cart-count:last-child');
    $('<div class="subtotal-disclaimer"><span>Discounts, shipping, and taxes calculated at checkout.</span></div>').insertAfter('#slidecarthq footer div.footer-row');
    
    //$('.note-trigger').text('Add an optional note to packing slip');
  } catch (error) {
    console.error(error);
  }
}